import React from "react";
import { InteractiveContainer } from "@jugl-web/ui-components";
import { Portal } from "@headlessui/react";

export const CXKnowledgeTrainingPopup: React.FC<{
  isOpen: boolean;
  title: string;
  img: React.ReactNode;
  subtitle: React.ReactNode;
  button: {
    text: string;
    onClick: () => void;
  };
}> = ({ isOpen, button, subtitle, title, img }) => {
  if (!isOpen) return null;
  return (
    <Portal>
      <div className="util-prevent-drawer-close animate-fade-in fixed bottom-10 right-10 z-[51] w-[360px] rounded-[20px] bg-[#333333]">
        <div className="border-dark-800 flex items-center justify-between gap-3 border-0 border-b border-solid py-[3px] pl-6">
          <span className="font-secondary text-lg font-semibold leading-[140%] text-white">
            {title}
          </span>
          {img}
        </div>
        <div className="py-2.5 px-6">
          <span className="font-secondary text-sm text-white">{subtitle}</span>
        </div>
        <div className="mx-6 mb-6 flex h-10 items-center justify-end px-2">
          <InteractiveContainer
            className="font-secondary bg-[linear-gradient(149deg,#A9BDFF_68.46%,#F79FFF_93.9%)] bg-clip-text text-sm font-semibold uppercase leading-3 text-transparent"
            onClick={button.onClick}
          >
            {button.text}
          </InteractiveContainer>
        </div>
      </div>
    </Portal>
  );
};
